<script setup lang="ts">
// Лендинг — одна страница; /privacy и /terms добавятся к прод-запуску.
import HomeView from './views/HomeView.vue'
</script>

<template>
  <HomeView />
</template>
